import { useState } from 'react';
import { motion } from 'framer-motion';
import './Page1.sass';
import HomeImage from '../../Components/Images/homeimage.jpg';
import Resume from '../../Components/Images/resume.pdf';
import { DocumentIcon, ArrowUpRightIcon, ChevronDownIcon, MenuIcon, CloseIcon } from '../../Components/Icons/Icons.js';
import ThemeToggle from '../../Components/ThemeToggle/ThemeToggle.js';

const navLinks = [
  { name: 'About', id: '#interests' },
  { name: 'Work', id: '#work' },
  { name: 'Projects', id: '#projects' },
  { name: 'Involvements', id: '#misc' },
];

function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="nav">
      <a className="nav_name fs2" href="#page1">
        <b>Bryan Bee</b>
      </a>

      <div className="nav_right">
        <div className={`nav_links ${open ? 'nav_links-open' : ''}`} onClick={() => setOpen(false)}>
          {navLinks.map((item) => (
            <a className="nav_link fs1" href={item.id} key={item.id}>
              {item.name}
            </a>
          ))}
        </div>

        <ThemeToggle />

        <button className="nav_toggle" onClick={() => setOpen((v) => !v)} aria-label="Toggle menu">
          {open ? <CloseIcon /> : <MenuIcon />}
        </button>
      </div>
    </nav>
  );
}

function Hero() {
  return (
    <div className="hero">
      <div className="hero_glow hero_glow-a" />
      <div className="hero_glow hero_glow-b" />

      <div className="hero_content">
        <motion.div
          className="hero_text"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="hero_badge fs1">console.log("Hello, I'm Bryan");</div>
          <h1 className="hero_heading fs4">
            Software Engineer building <span className="hero_heading-accent">fast, reliable</span> backend systems.
          </h1>
          <p className="hero_subtext fs2">
            Computer Science graduate focused on backend engineering, distributed systems, and cloud infrastructure
            — from real-time ad auctions to production APIs.
          </p>
          <div className="hero_actions">
            <a className="btn btn-primary fs1" href={Resume} target="_blank" rel="noopener noreferrer">
              <DocumentIcon /> Resume
            </a>
            <a className="btn btn-ghost fs1" href="#work">
              View my work <ArrowUpRightIcon />
            </a>
          </div>
        </motion.div>

        <motion.div
          className="hero_imagewrap"
          initial={{ opacity: 0, scale: 0.92 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="hero_imagering">
            <img className="hero_image" src={HomeImage} alt="Bryan Bee" />
          </div>
        </motion.div>
      </div>

      <a className="hero_scrollcue" href="#interests" aria-label="Scroll down">
        <ChevronDownIcon />
      </a>
    </div>
  );
}

function Page1() {
  return (
    <div className="page1_main" id="page1">
      <Nav />
      <Hero />
    </div>
  );
}

export default Page1;
